<template lang="pug">
#Dashboard.text-center
  .d-flex.justify-content-between.mb-2
    h4.title
      | Dashboard
      b-spinner.ml-3(v-if="loading" label="Cargando..." variant="primary")
    b-breadcrumb(:items="breadcrumbs")
  //- HeaderCards.mb-3
  MainTable
</template>

<script>
import { mapState, mapWritableState } from 'pinia'
import { mapGetters } from 'vuex'
import HeaderCards from '@/components/Dashboard/HeaderCards.vue'
import MainTable from '@/components/Dashboard/MainTable.vue'
import { useDashboardStore } from '../pinia/views/useDashboardStore'

export default {
  name: 'Dashboard',
  components: {
    HeaderCards,
    MainTable,
  },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { path: '/' },
        },
        {
          text: 'Dashboard',
          active: true,
        },
      ],
    }
  },
  methods: {},
  async created() {
    this.filters.tecnico = null
    this.$nextTick(() => {
      const { user } = JSON.parse(localStorage.getItem('user'))
      const functionalGroups = user.groups.filter(
        (g) => g.name !== 'SILL_USERS'
      )
      const isOnlyTechnician =
        functionalGroups.length === 1 &&
        functionalGroups.some((g) => g.name === 'Técnico')
      if (isOnlyTechnician) {
        this.filters.tecnico = user.id
      }
    })
  },
  computed: {
    ...mapState(useDashboardStore, ['loading']),
    ...mapWritableState(useDashboardStore, ['filters']),
    ...mapGetters('AuthenticationStore', ['user']),
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

#Dashboard {
  @include media-breakpoint-up(lg) {
    max-width: 90%;
    margin: 0 auto;
  }
}
.title {
  color: #74788d;
  font-weight: bold;
}
</style>
